<template>
<div class="el-tabs__inner">
  <b-row :gutter="10" class="row-bg">
    <draggable :list="baseFields" :clone="clone"
    class="dragArea"
    :group= "{ name:'formbuilder', pull:'clone', put:false }"
    :sort="false">
      <div style="width: 48%; margin-right: 5px; display: inline-block;" :class="{ 'is-disabled': checkStopDragCondition(field) }" v-for="(field, index) in baseFields" :key="index">
        <b-button class="mr-2 btn-block" variant="outline-info">
          {{ field.text }}
        </b-button>
      </div>
    </draggable>
  </b-row>
</div>
</template>
<script>
import {
  FormBuilder
} from '@/components/bs/formbuilder';
import draggable from 'vuedraggable';

export default {
  name: 'Elements',
  store: ['forms', 'baseFields'],
  components: {
    draggable
  },
  data() {
    return {
      // fields: FormBuilder.$data.fields,
      dropElementOptions: FormBuilder.$data.dropElementOptions
    };
  },
  methods: {
    uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },

    clone(field) {
      var cloned = _.cloneDeep(field);

      if(! cloned.id) {
        cloned.id = this.uuidv4()
      }

      return cloned
    },
    checkStopDragCondition(field) {
      var form = this.forms,
        formArray = [];

      for (var key in form) {
        formArray.push(form[key]['fieldType'])
      }
      // Check if the fieldname exist in formArray
      // And when the field.isUnique too
      return _.includes(formArray, field.name) && field.isUnique;
    }
  }
}
</script>

<style lang="scss" scoped>
.button__sidebar {
    width: 100%;
    margin-bottom: 5px;

    .is-disabled & {
        opacity: 0.4;
    }
}

// Display this ghost in <main> only
 .sortable__ghost {
    position: relative;
    width: 33.33%;
    border-bottom: 2px solid #3A8EE6;
    margin-top: 2px;
    margin-bottom: 2px;

    [type="button"] {
        display: none;
    }

    &:before {
        content: "Drag it here";
        background-color: #ECF5FF;
        color: #3A8EE6;
        position: absolute;
        left: 50%;
        font-size: 10px;
        border-radius: 10px;
        line-height: 15px;
        padding: 0 10px;
        top: -6px;
        transform: translateX(-50%);
    }
}
</style>
